import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";

const Logo = "/logo.png";

const Header = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  const getActiveClass = (isActive) =>
    isActive ? "active" : "";

  const navLinks = [
    { to: "/", label: "Home", end: true },
    { to: "/about", label: "About" },
    { to: "/services", label: "Services" },
    { to: "/careers", label: "Careers" },
    { to: "/learning", label: "Learning" },
  ];

  return (
    <>
      <header className="sticky top-0 z-50">
        <nav className="w-full main-nav">
          <div className="mx-auto max-w-[1280px] px-4 sm:px-6">
            <div className="flex items-center justify-between h-16">
              {/* Logo */}
              <NavLink to="/" className="flex-shrink-0">
                <img
                  className="logo"
                  src={Logo}
                  alt="Vivcloud Technologies"
                  width="140"
                  height="36"
                  fetchpriority="high"
                />
              </NavLink>

              {/* Desktop nav */}
              <ul className="nav-ul hidden md:flex items-center gap-1">
                {navLinks.map((link) => (
                  <li key={link.to}>
                    <NavLink
                      to={link.to}
                      end={!!link.end}
                      className={({ isActive }) => getActiveClass(isActive)}
                    >
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>

              {/* Desktop CTA */}
              <div className="hidden md:flex items-center gap-3">
                <NavLink to="/contact" className="nav-cta">
                  Get in Touch
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </NavLink>
              </div>

              {/* Mobile toggle */}
              <button
                aria-label="Toggle menu"
                className="md:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                {navbarOpen ? (
                  <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
                  </svg>
                ) : (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Mobile menu */}
          {navbarOpen && (
            <div className="md:hidden mobile-nav fade-in">
              <ul className="nav-ul flex flex-col gap-1">
                {navLinks.map((link) => (
                  <li key={link.to}>
                    <NavLink
                      to={link.to}
                      end={!!link.end}
                      onClick={() => setNavbarOpen(false)}
                      className={({ isActive }) => getActiveClass(isActive)}
                    >
                      {link.label}
                    </NavLink>
                  </li>
                ))}
                <li className="pt-2">
                  <NavLink
                    to="/contact"
                    onClick={() => setNavbarOpen(false)}
                    className="nav-cta justify-center w-full"
                  >
                    Get in Touch
                  </NavLink>
                </li>
              </ul>
            </div>
          )}
        </nav>
      </header>

      <a
        aria-label="Chat on WhatsApp"
        href="https://api.whatsapp.com/send?phone=918604042743"
        target="_blank"
        rel="noopener noreferrer"
        className="whats-app-pulse"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    </>
  );
};

export default Header;
